import { render, staticRenderFns } from "./CpuRelationDetailModal.vue?vue&type=template&id=5b4b361f&scoped=true"
import script from "./CpuRelationDetailModal.vue?vue&type=script&lang=js"
export * from "./CpuRelationDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CpuRelationDetailModal.vue?vue&type=style&index=0&id=5b4b361f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b361f",
  null
  
)

export default component.exports